// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class EmailSignatureTemplateRequest {
    static getAttributeTypeMap() {
        return EmailSignatureTemplateRequest.attributeTypeMap;
    }
}
EmailSignatureTemplateRequest.discriminator = undefined;
EmailSignatureTemplateRequest.additionalProperties = false;
EmailSignatureTemplateRequest.attributeTypeMap = [
    {
        "name": "programId",
        "baseName": "programId",
        "type": "number"
    },
    {
        "name": "accountId",
        "baseName": "accountId",
        "type": "number"
    },
    {
        "name": "documentType",
        "baseName": "documentType",
        "type": "string"
    },
    {
        "name": "brandId",
        "baseName": "brandId",
        "type": "string"
    },
    {
        "name": "senderId",
        "baseName": "senderId",
        "type": "string"
    },
    {
        "name": "templateId",
        "baseName": "templateId",
        "type": "string"
    },
    {
        "name": "expireInDays",
        "baseName": "expireInDays",
        "type": "number"
    },
    {
        "name": "emailSubject",
        "baseName": "emailSubject",
        "type": "string"
    },
    {
        "name": "emailBody",
        "baseName": "emailBody",
        "type": "string"
    },
    {
        "name": "send",
        "baseName": "send",
        "type": "boolean"
    },
    {
        "name": "embedded",
        "baseName": "embedded",
        "type": "boolean"
    },
    {
        "name": "recipients",
        "baseName": "recipients",
        "type": ""
    },
    {
        "name": "fields",
        "baseName": "fields",
        "type": ""
    },
    {
        "name": "attestations",
        "baseName": "attestations",
        "type": ""
    },
    {
        "name": "enterpriseDBDocuments",
        "baseName": "enterpriseDBDocuments",
        "type": ""
    },
];
//# sourceMappingURL=emailSignatureTemplateRequest.js.map